import { Flex, FlexProps, Grid, GridProps, useBreakpointValue } from "@chakra-ui/react";
import { ReactNode } from "react";

interface LayoutProps extends FlexProps {
  children: ReactNode | ReactNode[];
}

interface LayoutGridProps extends GridProps {
  children: ReactNode | ReactNode[];
}

export function Layout({ children, ...rest }: LayoutProps) {
  const Wide = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });

  return (
    <Flex
      w="full"
      // minH={!Wide && "unset"}
      justify="center"
      py={Wide ? 0 : "3.8rem"}
      as="main"
      position="relative"
      // mb={"50px"}
      {...rest}
    >
      {children}
    </Flex>
  );
}

export function LayoutGrid({ children, ...rest }: LayoutGridProps) {
  return (
    <Flex>
      <Grid {...rest}>{children}</Grid>
    </Flex>
  );
}

interface listProps extends FlexProps {
  sidebarSize: boolean;
  zindex: number;
}

export function ContentBox({ children, ...rest }: LayoutProps) {
  return (
    <Flex maxW="1250px" width="100%" {...rest}>
      {children}
    </Flex>
  );
}

export const LayoutSidebar = ({ children, sidebarSize, zindex, ...rest }: listProps) => {
  return (
    <Flex
      {...rest}
      width="85%"
      height="100%"
      maxHeight="100vh"
      direction="column"
      alignItems="center"
      backgroundColor="white"
      position="fixed"
      top="0"
      left={sidebarSize ? "0" : "-100vw"}
      transition="all ease .6s"
      pt="5px"
      m="0"
      zIndex={zindex}
      boxSizing="border-box"
      overflowY="scroll"
    >
      <Flex direction="column" width="85%" m="15px 0 10px 0">
        {children}
      </Flex>
    </Flex>
  );
};
